import AnchorAPI from '../AnchorAPI';

interface LoginRequestUser {
  userIdentities: {
    customerid?: string;
    email?: string;
    other?: string;
  };
}

export function initializeWithUser(
  isLoggedIn: boolean,
  shareableUserId?: string,
  optimizelyUserId?: string
) {
  if (typeof mParticle === 'undefined') {
    return;
  }
  if (isLoggedIn) {
    AnchorAPI.getUserEmailAddress().then(emailAddress => {
      if (emailAddress) {
        setUpIdentity(emailAddress, shareableUserId, optimizelyUserId);
      }
    });
  }
}

function setUpIdentity(
  emailAddress: string,
  shareableUserId?: string,
  optimizelyUserId?: string
) {
  const loginRequestUserObject: LoginRequestUser = { userIdentities: {} };

  if (shareableUserId && emailAddress && optimizelyUserId) {
    loginRequestUserObject.userIdentities.customerid = shareableUserId;
    loginRequestUserObject.userIdentities.email = emailAddress;
    loginRequestUserObject.userIdentities.other = optimizelyUserId;

    // @ts-ignore
    mParticle.Identity.login(loginRequestUserObject, onLoginResult);
  }

  function onLoginResult(result: any) {
    if (result.httpCode === 429) {
      // in rare circumstances, requests will be throttled and need to be retried
      setUpIdentity(emailAddress, shareableUserId, optimizelyUserId);
    }
  }
}
